var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepartamentos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 175H175M75 66.6667H83.3333M75 100H83.3333M75 133.333H83.3333M116.667 66.6667H125M116.667 100H125M116.667 133.333H125M41.6667 175V41.6667C41.6667 37.2464 43.4226 33.0072 46.5482 29.8816C49.6738 26.7559 53.9131 25 58.3333 25H141.667C146.087 25 150.326 26.7559 153.452 29.8816C156.577 33.0072 158.333 37.2464 158.333 41.6667V175",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartamentos);
export default __webpack_public_path__ + "static/media/Departamentos.be4e62b600ca2b9400aa7f9dbe6fc622.svg";
export { ForwardRef as ReactComponent };